import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { BriefPolicy } from '../shared/models/brief-policy.model';
import { DashboardDetails } from '../shared/models/dashboard-details.model';
import { PolicyData } from '../shared/models/policy-data.model';

@Injectable({
  providedIn: 'root',
})
export class AdviserApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly apiBaseUrl = environment.apiUrl;

  constructor() {}

  async getPolicies(adviserNumber: string): Promise<DashboardDetails> {
    return firstValueFrom(
      this.httpClient.get<DashboardDetails>(
        this.apiBaseUrl + '/advisers/' + adviserNumber + '/details',
      ),
    );
  }

  async getPolicyBrief(policyNumber: string): Promise<BriefPolicy> {
    return firstValueFrom(
      this.httpClient.get<BriefPolicy>(this.apiBaseUrl + '/policies/' + policyNumber + '/brief'),
    );
  }

  async getPolicyFull(policyNumber: string): Promise<PolicyData> {
    return firstValueFrom(
      this.httpClient.get<PolicyData>(this.apiBaseUrl + '/policies/' + policyNumber),
    );
  }
}

